import React, {useState} from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { faChevronRight, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CareerCategory from './CareerCategory';
import TopJobPosts from '../../job/components/TopJobPosts';
import TopTopics from '../../topic/components/TopTopics';
import { snap, testimonial } from '../../utils/widgetUtils';

function HomeLg() {

    const [btnHover, setBtnHover] = useState(false);

    const btnEnter = () => {
        setBtnHover(true);
    };
    const btnLeave = () => {
        setBtnHover(false);
    };

    const topicCategoryParams = {
        entry: "Topic",
        targetUrl: "/topics"
    }

    const styles = {
        feature: {
            section:{
                background:'#fff', 
                paddingTop:30, 
                paddingBottom: 30,
            },
            body:{
                background:'#fff', 
                paddingTop:50, 
                paddingBottom: 30,
            },
            title:{
                fontSize:32,
                marginBottom: 10
            },
            brandDot:{
                color: '#00a823',
                fontSize: 32,
                fontWeight: 600,
                lineHeight: 1
            },
            info:{
                color: '#333',
                fontSize:16,
                marginBottom: 30,
            },
            snap: {
                marginBottom: 40,
            },
            btn: {
                background: btnHover ? '#228837' : '#26ab42',
                color: '#fff',
                width:220,
                boxShadow: '0px 0px 5px #999'
            },
        },
        testimonial:{
            wrap: {
                paddingTop: 10
            },
            body: {
                marginBottom: 10,
            },
            action:{
                fontSize: 15,
                textDecoration: 'none'
            }
        },
        topJobs: {
            background:'#fff', 
            paddingTop:60, 
            paddingBottom: 60,
        },
        topTopics: {
            background:'#fff', 
            paddingTop:60, 
            paddingBottom: 60,
        },
        topics: {
            section:{
                background:'#eefbec', 
                paddingTop:60, 
                paddingBottom: 60,
            },
            title:{
                fontSize:24,
                fontWeight:400,
                marginBottom: 5
            },
            info: {
                marginBottom: 20,
                fontSize:16,
            },
            btn: {
                background: btnHover ? '#228837' : '#26ab42',
                color: '#fff',
                width:220,
                boxShadow: '0px 0px 5px #999'
            },
        }
    }

    return (
        <>
        <section style={styles.feature.section}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-7'>
                        <div style={styles.feature.body}>
                            <h1 style={styles.feature.title}>Get Top Jobs, Career Updates, and Connections<span style={styles.feature.brandDot}>.</span></h1>
                            <p style={styles.feature.info}>Apply for top jobs, get top talents, upscale your career and linkup with professionals.</p>
                            <div style={styles.feature.snap}>{snap("desktop")}</div>
                            <a href={`/user/sign-up/start`} style={styles.feature.btn} className='btn' onMouseEnter={btnEnter} onMouseLeave={btnLeave}>
                            GET STARTED FOR FREE &nbsp; <FontAwesomeIcon icon={faChevronRight} />
                            </a>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                    <div className='col-md-4'>
                        <div style={styles.testimonial.wrap}>
                            <div style={styles.testimonial.body}>
                                {testimonial("desktop")}
                            </div>
                            <a href={`/user/sign-up/start`} style={styles.testimonial.action}>
                                <FontAwesomeIcon icon={faPlus} /> Click to Join
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section style={styles.topJobs}>
            <div className='container'>
                <TopJobPosts />
            </div>
        </section>

        <section style={styles.topTopics}>
            <div className='container'>
                <TopTopics />
            </div>
        </section>

        <section style={styles.topics.section}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-5'>
                        <h2 style={styles.topics.title}>Explore collaborative articles</h2>
                        <div style={styles.topics.info}>We’re unlocking community knowledge in a new way. Experts add insights directly into each article, started with the help of AI. </div>
                    </div>
                    <div className='col-md-7'>
                     <CareerCategory params={topicCategoryParams} />
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default HomeLg;